import { createAction, props } from '@ngrx/store';

import { MasterData } from 'app/shared/models';

export const initializingMasterDataStore = createAction('[MasterData] Initializing Store');

export const startPeriodicMasterDataUpdates = createAction('[MasterData] Start Periodic Master Data Updates');

export const refreshMasterData = createAction('[MasterData] Refresh Master Data');

export const loadMasterDataFromServer = createAction('[MasterData] Load Master Data From Server');

export const preloadMasterDataFinished = createAction(
    '[MasterData] Preload Master Data Finished',
    props<{ masterData: MasterData }>(),
);

export const loadMasterDataSuccess = createAction(
    '[MasterData] Load Master Data Success',
    props<{ masterData: MasterData }>(),
);

export const loadMasterDataFailure = createAction(
    '[MasterData] Load Master Data Failure',
    props<{ error: string }>(),
);
export const loadMasterDataCancelled = createAction('[MasterData] Load Master Data Cancelled');

export const resetMasterDataState = createAction('[MasterData] Reset Master Data State');
